import React from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

/**
 * One of the bell's notices: its title, and the first line of its text. Both are plain text from the
 * server, shown as text.
 */
const NoticeContent = ({ notice }) => {
  const firstLine = (notice?.body || '').split('\n')[0];
  return (
    <div>
      <Text strong>{notice?.title}</Text>
      {firstLine ? (
        <div>
          <Text type="secondary" style={{ fontSize: '12px' }}>
            {firstLine}
          </Text>
        </div>
      ) : null}
    </div>
  );
};

/** The bell's notices not seen yet. */
export const unseenNotices = notices => ((notices && notices.items) || []).filter(n => !n.seen);

export default NoticeContent;
